export default "__VITE_ASSET__k$g2bTmO__"